var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-editor---publish-success",
    transform: "translate(-401.000000, -15.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "sparkle-1",
    d: "M413,32.5 C414.198,32.865 415.135,33.803 415.499,35 C415.865,33.802 416.803,32.865 418,32.5 C416.803,32.134 415.866,31.198 415.499,30 C415.135,31.197 414.198,32.134 413,32.5 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "sparkle-2",
    style: {
      transitionDelay: "0.10s"
    },
    d: "M419,26.999 C420.437,27.437 421.562,28.563 421.999,30 C422.439,28.563 423.564,27.438 425,27 C423.564,26.561 422.439,25.437 421.999,24 C421.562,25.436 420.437,26.561 419,26.999 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sparkle-3",
    style: {
      transitionDelay: "0.05s"
    },
    d: "M412,19.999 C414.395,20.73 416.27,22.606 416.999,25 C417.732,22.605 419.607,20.731 422,20 C419.607,19.269 417.732,17.395 416.999,15 C416.27,17.394 414.395,19.268 412,19.999 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sparkle-4",
    style: {
      transitionDelay: "0.15s"
    },
    d: "M407,24.228 C407.522,24.886 408.118,25.481 408.775,26.003 C408.118,26.525 407.523,27.12 407.002,27.777 C406.48,27.119 405.884,26.524 405.226,26.001 C405.884,25.48 406.478,24.885 407,24.228 Z M406.999,20 C406.124,22.873 403.871,25.125 401,26.001 C403.876,26.881 406.124,29.129 407.004,32.005 C407.879,29.131 410.132,26.881 413,26.001 C410.132,25.127 407.879,22.874 406.999,20 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSparkles);
export default __webpack_public_path__ + "static/media/icon-sparkles.3e039b155f5464093277bd6084338114.svg";
export { ForwardRef as ReactComponent };